// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { features: { __typename: 'Features', id: string, marketingEnabled: boolean | undefined, marketingEnabledSMS: boolean | undefined, marketingEnabledCall: boolean | undefined, videoNotificationsDisabled: boolean | undefined, uBTC: boolean | undefined, mBTC: boolean | undefined, VIP: boolean | undefined, Insider: boolean | undefined, isAmsUser: boolean | undefined, isVip: boolean | undefined, isConfirmedOppositeBetting: boolean | undefined, isLoyaltyDisabled: boolean | undefined, lcToBcCompleted: boolean | undefined } | undefined };

export type TagsFragment = { __typename: 'Features', id: string, marketingEnabled: boolean | undefined, marketingEnabledSMS: boolean | undefined, marketingEnabledCall: boolean | undefined, videoNotificationsDisabled: boolean | undefined, uBTC: boolean | undefined, mBTC: boolean | undefined, VIP: boolean | undefined, Insider: boolean | undefined, isAmsUser: boolean | undefined, isVip: boolean | undefined, isConfirmedOppositeBetting: boolean | undefined, isLoyaltyDisabled: boolean | undefined, lcToBcCompleted: boolean | undefined };

export const TagsFragmentDoc = gql`
    fragment TagsFragment on Features {
  __typename
  id
  marketingEnabled: hasTag(name: "marketingEnabled")
  marketingEnabledSMS: hasTag(name: "marketingEnabledSMS")
  marketingEnabledCall: hasTag(name: "marketingEnabledCall")
  videoNotificationsDisabled: hasTag(name: "videoNotificationsDisabled")
  uBTC: hasTag(name: "uBTC")
  mBTC: hasTag(name: "mBTC")
  VIP: hasTag(name: "VIP")
  Insider: hasTag(name: "Insider")
  isAmsUser: hasTag(name: "Agent System User")
  isVip: hasGroupTag(name: "VIP Manager")
  isConfirmedOppositeBetting: hasTag(name: "Confirmed Opposite Betting")
  isLoyaltyDisabled: hasTag(name: "loyalty_disabled")
  lcToBcCompleted: hasTag(name: "LCtoBCcompleted")
}
    `;
export const TagsQueryDocument = gql`
    query TagsQuery {
  features {
    ...TagsFragment
  }
}
    ${TagsFragmentDoc}`;